var map = {
	"./3xcalibur.png": 87421,
	"./acyfinance.svg": 13470,
	"./alienfi.png": 73021,
	"./alligator.svg": 97143,
	"./antfarmfinance.png": 15286,
	"./apeswap.svg": 31746,
	"./apex.svg": 84954,
	"./arbiswap.png": 70270,
	"./arbswap.svg": 75364,
	"./avatanetwork.svg": 96727,
	"./avaxpad.svg": 44322,
	"./babydogeswap.png": 99621,
	"./babyswap.png": 27472,
	"./baguette.png": 81874,
	"./bakery.svg": 9629,
	"./ballswapper.png": 40222,
	"./bamboo.svg": 99785,
	"./baoswap.png": 25597,
	"./baryon.svg": 46078,
	"./bionicswap.png": 36262,
	"./biswap.png": 4537,
	"./bitblocks.png": 18106,
	"./blockstar.svg": 47775,
	"./bluelotus.svg": 1921,
	"./borgswap.png": 23392,
	"./bullcoin.png": 54412,
	"./bxh.png": 34140,
	"./camelot.png": 49398,
	"./canaryexchange.svg": 59358,
	"./chronos.png": 1663,
	"./cobra.svg": 52490,
	"./coinone.png": 41430,
	"./cometh.png": 62355,
	"./complus.png": 11317,
	"./concave.svg": 94271,
	"./cone.svg": 37519,
	"./cox.svg": 16167,
	"./crowdswap.png": 59716,
	"./cryptodefi.png": 10677,
	"./cryptoswap.png": 32903,
	"./curve.png": 10073,
	"./darswap.svg": 13887,
	"./dctdao.png": 21755,
	"./definix.png": 86677,
	"./despace.svg": 94266,
	"./dexfinance.png": 72430,
	"./dexvers.svg": 11662,
	"./dfyn.png": 87418,
	"./digidex.svg": 87263,
	"./dino.svg": 9082,
	"./dinosaureggs.png": 27245,
	"./dodo.svg": 56311,
	"./dojo.svg": 92594,
	"./dooarswap.svg": 64574,
	"./dystopia.svg": 88596,
	"./edenswap.png": 79679,
	"./elkfinance.png": 90643,
	"./elkfinance.svg": 2371,
	"./empiredex.png": 1903,
	"./ethax.svg": 85635,
	"./evoc.svg": 25551,
	"./extendswap.png": 85034,
	"./famoso.svg": 99084,
	"./farmageddon.svg": 46241,
	"./firebird.svg": 66005,
	"./forge.png": 17141,
	"./foxdex.png": 41204,
	"./fraxfinance.png": 67414,
	"./fst.png": 58986,
	"./glacierfinance.png": 90279,
	"./gravityfinance.png": 19320,
	"./groveswap.png": 59137,
	"./hakuswap.png": 70930,
	"./hkswap.png": 4421,
	"./hodlx.svg": 77450,
	"./hunnyswap.png": 88415,
	"./hurricaneswap.png": 79557,
	"./hyperjump.png": 37837,
	"./if.png": 50326,
	"./inediblex.png": 43721,
	"./infinity.svg": 78845,
	"./integral.png": 51545,
	"./jamon.png": 36797,
	"./jetswap.png": 34182,
	"./justliquidity.png": 52486,
	"./justmoney.svg": 4951,
	"./kasaswap.svg": 23029,
	"./knight.svg": 83618,
	"./kronosdao.svg": 12853,
	"./kyberswap.png": 24648,
	"./kyberswap.svg": 50444,
	"./kyotoswap.png": 75523,
	"./leonicorn.png": 2733,
	"./leonicorn.svg": 57919,
	"./lfgswap.png": 3807,
	"./linkedfinance.svg": 31759,
	"./litedex.svg": 59463,
	"./luaswap.png": 58623,
	"./luchowswap.png": 9362,
	"./lydiafinance.png": 76387,
	"./mars.png": 99424,
	"./mdex.png": 31023,
	"./melegaswap.svg": 18691,
	"./metastake.png": 85528,
	"./metaswap.svg": 57962,
	"./minty.svg": 81709,
	"./mintydao.png": 24632,
	"./mmf.png": 26099,
	"./mochiswap.png": 68067,
	"./moonlift.svg": 45144,
	"./myteamex.png": 73044,
	"./nacho.png": 97918,
	"./nativefinance.svg": 25524,
	"./niob.svg": 29307,
	"./nomi.png": 53695,
	"./novation.svg": 84581,
	"./olivecash.png": 7677,
	"./oooswap.png": 28406,
	"./orbital.svg": 98253,
	"./oreoswap.png": 38701,
	"./padswap.png": 28271,
	"./pancakeswap.png": 27504,
	"./pandora.png": 13632,
	"./pangolin.png": 47598,
	"./pankuku.png": 14609,
	"./partyswap.png": 41574,
	"./pepepal.png": 62185,
	"./peppswap.png": 29206,
	"./pieswap.svg": 37234,
	"./pippi.svg": 82539,
	"./planet.png": 76520,
	"./playground.png": 29241,
	"./pls2e.svg": 30555,
	"./polkabridgeamm.svg": 92502,
	"./polycat.png": 61875,
	"./ponyswap.png": 88177,
	"./pyeswap.svg": 29708,
	"./quickswap.png": 38579,
	"./radioshack.png": 75288,
	"./radioshack.svg": 190,
	"./ramses.png": 24003,
	"./rareswap.svg": 34963,
	"./reflectoswap.svg": 25079,
	"./renaswap.svg": 72152,
	"./robocex.png": 85153,
	"./robustswap.svg": 72968,
	"./safemoon.svg": 11900,
	"./safuswap.png": 62529,
	"./saitaswap.png": 76979,
	"./sea.png": 2034,
	"./sharkyswap.png": 34907,
	"./sheepdex.png": 78887,
	"./shibanova.png": 58624,
	"./shibaswap.png": 4929,
	"./shibceo.png": 85237,
	"./shibnobi.svg": 67682,
	"./smardex.png": 11253,
	"./smartswap.png": 26439,
	"./smb.svg": 78195,
	"./smeg.svg": 29151,
	"./solidlizard.png": 62421,
	"./solidly.png": 20916,
	"./sphynx.svg": 41978,
	"./spicetrade.jpg": 71807,
	"./stableworld.svg": 85740,
	"./starzswap.png": 66939,
	"./stormswap.png": 42863,
	"./sugarswap.png": 3082,
	"./sushiswap.png": 18350,
	"./swaperyx.png": 26552,
	"./swapfish.png": 97434,
	"./swapocean.svg": 70103,
	"./swappery.svg": 84483,
	"./swapr.svg": 39257,
	"./swapsicle.png": 16786,
	"./swapx.svg": 5864,
	"./swych.svg": 82463,
	"./techswap.webp": 56341,
	"./teddy.svg": 35629,
	"./tetu.svg": 35638,
	"./thena.png": 94704,
	"./thorus.svg": 53658,
	"./traderjoe.png": 7973,
	"./tresleches.svg": 92559,
	"./twoge.png": 95637,
	"./unify.png": 62878,
	"./uniswap.png": 92396,
	"./uniswap.svg": 50080,
	"./uniswap2.svg": 99723,
	"./unitedfarmers.png": 21125,
	"./unknown.png": 82393,
	"./vapordex.png": 12079,
	"./veneraswap.svg": 4209,
	"./versedex.png": 69497,
	"./vulcandex.svg": 11947,
	"./w3swap.svg": 50879,
	"./wakandainu.png": 9825,
	"./wault.png": 40967,
	"./winery.svg": 97091,
	"./xchange.png": 41673,
	"./yetiswap.png": 71654,
	"./yoshi.svg": 27663,
	"./zenithswap.png": 30689,
	"./zswap.svg": 94994,
	"./zyberswap.png": 59553
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 89393;